<div class="otp-container">
  <input
    *ngFor="let i of inputs; let idx = index"
    #otpInput
    type="text"
    inputmode="numeric"
    pattern="[0-9]*"
    maxlength="1"
    class="otp-input"
    (keyup)="onKeyUp($event, idx)"
    (keydown)="onKeyDown($event, idx)"
    (paste)="onPaste($event, idx)"
    [value]="value[idx] || ''"
    (input)="onInput($event, idx)"
  />
</div>
